import classes from './Chip.module.scss'

export interface ChipProps {
  children: React.ReactNode
  noWrap?: boolean
  hasBorder?: boolean
}

const Chip = ({
  children,
  noWrap = false,
  hasBorder = true
}: ChipProps) => {
  const wrapClass = noWrap
    ? classes.noWrap
    : ''

  const borderClass = !hasBorder
    ? classes.withoutBorder
    : ''

  const finalClasses = [
    classes.Chip,
    wrapClass,
    borderClass
  ].filter(classname => classname).join(' ')

  return (
    <span
      className={finalClasses}
    >
      {children}
    </span>
  )
}

export default Chip
